<script async setup lang="ts">
const { $axios }: any = useNuxtApp();

const headers = ref<any>([]);
const fetchData = async () => {
  try {
    const response = await $axios("/cms/header-images/get");
    if (!response || !response.data) throw new Error("No data received");
    headers.value = response.data;
  } catch (error) {
    console.error("Error fetching header:", error);
  }
};

onMounted(() => {
  fetchData();
});
</script>

<template>
  <ClientOnly>
    <Swiper
      :modules="[SwiperAutoplay]"
      :slides-per-view="1"
      :loop="true"
      :autoplay="{
        delay: 4000,
        disableOnInteraction: true,
      }"
      class="!overflow-visible !relative"
    >
      <SwiperSlide v-for="(header, idx) in headers" :key="idx">
        <div class="relative h-[110vh] sm:h-[60vh] w-full">
          <!-- Background image Desktop -->
          <NuxtImg
            :src="header.images"
            :alt="`banner-${header.title}`"
            quality="30"
            decoding="async"
            priority
            class="hidden sm:block absolute inset-0 w-full h-full object-cover z-0"
          />

          <!-- Background image Mobile -->
          <NuxtImg
            :src="header.image_mobile"
            :alt="`banner-${header.title}`"
            quality="30"
            decoding="async"
            priority
            class="block sm:hidden absolute inset-0 w-full h-full object-cover z-0"
          />

          <!-- Overlay hitam -->
          <div
            class="absolute inset-0 z-10 bg-gradient-to-tr from-black/100 to-black/20"
          ></div>

          <div
            class="container relative z-20 flex flex-col justify-end pb-8 sm:pb-24 h-full px-4"
          >
            <h1 class="text-2xl text-white lg:text-4xl font-medium">{{ header.title }}</h1>
            <p class="text-sm text-white font-light mt-2">
              {{ header.description }}
            </p>

            <div class="flex text-white items-center my-6 text-xs sm:text-base font-light">
              <Icon name="mdi:star" class="bg-yellow-500 mr-4" size="25" />
              <div>
                Rated 5/5 on Google Reviews - Trusted by Hundreds of Happy
                Riders
              </div>
            </div>
            
            <div class="block sm:hidden">
              <AdsForm />
            </div>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
  </ClientOnly>
</template>
